"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import { Button, Checkbox, Input, Label, Popover, PopoverContent, PopoverTrigger } from "@/components/ui";
import { useLocations } from "@/hooks/use-locations";
import { cx } from "@/lib/tailwind-utils";
interface LocationSelectProps {
  value: string[];
  onChange: (locationIds: string[]) => void;
  className?: string;
  visibleLocationIds?: string[];
}
export default function LocationSelect(t0) {
  const $ = _c(97);
  const {
    value,
    onChange,
    className
  } = t0;
  const {
    locations,
    isLocationsLoading
  } = useLocations();
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [tempSelection, setTempSelection] = useState(value);
  const [error, setError] = useState("");
  let t1;
  let t2;
  if ($[0] !== value) {
    t1 = () => {
      setTempSelection(value);
      setError("");
    };
    t2 = [value];
    $[0] = value;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== locations || $[4] !== searchTerm) {
    let t4;
    if ($[6] !== searchTerm) {
      t4 = location => `${location.name}${location.isVirtual ? " (Virtual)" : ""}`.toLowerCase().includes(searchTerm.toLowerCase());
      $[6] = searchTerm;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = locations.filter(t4);
    $[3] = locations;
    $[4] = searchTerm;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const filteredLocations = t3;
  let T0;
  let T1;
  let handleApply;
  let handleCancel;
  let isTempNothingSelected;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[8] !== className || $[9] !== error || $[10] !== filteredLocations || $[11] !== isLocationsLoading || $[12] !== isOpen || $[13] !== locations || $[14] !== onChange || $[15] !== searchTerm || $[16] !== tempSelection || $[17] !== value) {
    t18 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const allLocationIds = locations.map(_temp);
      isTempNothingSelected = tempSelection === null;
      const isTempAllSelected = tempSelection !== null && (tempSelection.length === 0 || allLocationIds.length > 0 && allLocationIds.every(id => tempSelection.includes(id)));
      const someSelected = tempSelection !== null && tempSelection.length > 0 && !isTempAllSelected && filteredLocations.some(location_0 => tempSelection.includes(location_0.id));
      let t19;
      if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = checked => {
          if (checked) {
            setTempSelection([]);
          } else {
            setTempSelection(null);
          }
          setError("");
        };
        $[38] = t19;
      } else {
        t19 = $[38];
      }
      const handleSelectAll = t19;
      const handleLocationChange = (locationId, checked_0) => {
        if (checked_0) {
          if (tempSelection === null) {
            setTempSelection([locationId]);
          } else {
            if (tempSelection.length === 0) {
              setTempSelection([]);
            } else {
              const newSelection = [...tempSelection, locationId];
              if (allLocationIds.every(id_0 => newSelection.includes(id_0))) {
                setTempSelection([]);
              } else {
                setTempSelection(newSelection);
              }
            }
          }
        } else {
          if (tempSelection === null) {
            return;
          } else {
            if (tempSelection.length === 0) {
              const newSelection_0 = allLocationIds.filter(id_1 => id_1 !== locationId);
              setTempSelection(newSelection_0);
            } else {
              const newSelection_1 = tempSelection.filter(id_2 => id_2 !== locationId);
              if (newSelection_1.length === 0) {
                setTempSelection(null);
              } else {
                setTempSelection(newSelection_1);
              }
            }
          }
        }
        setError("");
      };
      let t20;
      if ($[39] !== isTempNothingSelected || $[40] !== onChange || $[41] !== tempSelection) {
        t20 = () => {
          if (isTempNothingSelected) {
            setError("You must select at least 1 location");
            return;
          }
          onChange(tempSelection);
          setIsOpen(false);
        };
        $[39] = isTempNothingSelected;
        $[40] = onChange;
        $[41] = tempSelection;
        $[42] = t20;
      } else {
        t20 = $[42];
      }
      handleApply = t20;
      let t21;
      if ($[43] !== value) {
        t21 = () => {
          setTempSelection(value);
          setError("");
          setIsOpen(false);
        };
        $[43] = value;
        $[44] = t21;
      } else {
        t21 = $[44];
      }
      handleCancel = t21;
      if (isLocationsLoading) {
        let t22;
        if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
          t22 = <Button variant="secondary" disabled={true} className="w-full justify-between">Loading locations...</Button>;
          $[45] = t22;
        } else {
          t22 = $[45];
        }
        let t23;
        if ($[46] !== className) {
          t23 = <div className={className}>{t22}</div>;
          $[46] = className;
          $[47] = t23;
        } else {
          t23 = $[47];
        }
        t18 = t23;
        break bb0;
      }
      const getDisplayText = () => {
        if (value.length === 0 || allLocationIds.length > 0 && allLocationIds.every(id_3 => value.includes(id_3))) {
          return "All";
        }
        return value.length.toString();
      };
      t17 = className;
      T1 = Popover;
      t13 = true;
      t14 = isOpen;
      t15 = setIsOpen;
      const t22 = <Button variant="secondary" className="flex w-full justify-start gap-1.5 font-normal">Selected Locations<span className={cx("flex shrink-0 items-center justify-center rounded bg-muted px-1 tabular-nums text-foreground", (value.length === 0 || allLocationIds.length > 0 && allLocationIds.every(id_4 => value.includes(id_4))) && "text-caption")}>{getDisplayText()}</span></Button>;
      if ($[48] !== t22) {
        t16 = <PopoverTrigger asChild={true} className="w-full">{t22}</PopoverTrigger>;
        $[48] = t22;
        $[49] = t16;
      } else {
        t16 = $[49];
      }
      T0 = PopoverContent;
      t11 = "z-50 min-w-[calc(var(--radix-popover-trigger-width))] max-w-[calc(var(--radix-popover-trigger-width))] sm:min-w-80 sm:max-w-80";
      t12 = "end";
      t8 = "flex h-full max-h-96 flex-col gap-3";
      let t23;
      if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = e => setSearchTerm(e.target.value);
        $[50] = t23;
      } else {
        t23 = $[50];
      }
      if ($[51] !== searchTerm) {
        t9 = <Input placeholder="Search for locations" value={searchTerm} onChange={t23} />;
        $[51] = searchTerm;
        $[52] = t9;
      } else {
        t9 = $[52];
      }
      if ($[53] !== error || $[54] !== isTempNothingSelected) {
        t10 = (error || isTempNothingSelected) && <div className="rounded-md bg-status-error-bg p-2 text-body text-status-error-text">{error || "You must select at least 1 location"}</div>;
        $[53] = error;
        $[54] = isTempNothingSelected;
        $[55] = t10;
      } else {
        t10 = $[55];
      }
      t6 = "flex-grow overflow-y-auto";
      const t24 = isTempAllSelected ? true : someSelected ? "indeterminate" : false;
      let t25;
      if ($[56] !== t24) {
        t25 = <Checkbox id="select-all-locations" checked={t24} onCheckedChange={handleSelectAll} />;
        $[56] = t24;
        $[57] = t25;
      } else {
        t25 = $[57];
      }
      let t26;
      if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = <Label className="w-full text-body-strong" htmlFor="select-all-locations">All Available Locations</Label>;
        $[58] = t26;
      } else {
        t26 = $[58];
      }
      if ($[59] !== t25) {
        t7 = <div className="sticky top-0 z-50 flex items-center gap-2 rounded-md bg-muted px-2 py-2">{t25}{t26}</div>;
        $[59] = t25;
        $[60] = t7;
      } else {
        t7 = $[60];
      }
      t4 = "ml-4 mt-2 flex flex-col gap-2";
      t5 = filteredLocations.length > 0 ? filteredLocations.map(location_1 => <div key={location_1.id} className="flex items-center gap-2"><Checkbox id={location_1.id} checked={tempSelection !== null && (tempSelection.length === 0 || tempSelection.includes(location_1.id))} onCheckedChange={checked_1 => handleLocationChange(location_1.id, checked_1)} /><Label className="w-full text-body" htmlFor={location_1.id}><span>{location_1.name}{location_1.isVirtual ? <span>{" (Virtual)"}</span> : <span>{""}</span>}</span></Label></div>) : <span className="text-body text-muted-foreground">No locations found</span>;
    }
    $[8] = className;
    $[9] = error;
    $[10] = filteredLocations;
    $[11] = isLocationsLoading;
    $[12] = isOpen;
    $[13] = locations;
    $[14] = onChange;
    $[15] = searchTerm;
    $[16] = tempSelection;
    $[17] = value;
    $[18] = T0;
    $[19] = T1;
    $[20] = handleApply;
    $[21] = handleCancel;
    $[22] = isTempNothingSelected;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
  } else {
    T0 = $[18];
    T1 = $[19];
    handleApply = $[20];
    handleCancel = $[21];
    isTempNothingSelected = $[22];
    t10 = $[23];
    t11 = $[24];
    t12 = $[25];
    t13 = $[26];
    t14 = $[27];
    t15 = $[28];
    t16 = $[29];
    t17 = $[30];
    t18 = $[31];
    t4 = $[32];
    t5 = $[33];
    t6 = $[34];
    t7 = $[35];
    t8 = $[36];
    t9 = $[37];
  }
  if (t18 !== Symbol.for("react.early_return_sentinel")) {
    return t18;
  }
  let t19;
  if ($[61] !== t4 || $[62] !== t5) {
    t19 = <div className={t4}>{t5}</div>;
    $[61] = t4;
    $[62] = t5;
    $[63] = t19;
  } else {
    t19 = $[63];
  }
  let t20;
  if ($[64] !== t19 || $[65] !== t6 || $[66] !== t7) {
    t20 = <div className={t6}>{t7}{t19}</div>;
    $[64] = t19;
    $[65] = t6;
    $[66] = t7;
    $[67] = t20;
  } else {
    t20 = $[67];
  }
  let t21;
  if ($[68] !== handleCancel) {
    t21 = <Button variant="secondary" className="h-8" type="button" onClick={handleCancel}>Cancel</Button>;
    $[68] = handleCancel;
    $[69] = t21;
  } else {
    t21 = $[69];
  }
  let t22;
  if ($[70] !== handleApply || $[71] !== isTempNothingSelected) {
    t22 = <Button variant="primary" className="h-8" type="button" onClick={handleApply} disabled={isTempNothingSelected}>Apply</Button>;
    $[70] = handleApply;
    $[71] = isTempNothingSelected;
    $[72] = t22;
  } else {
    t22 = $[72];
  }
  let t23;
  if ($[73] !== t21 || $[74] !== t22) {
    t23 = <div className="mt-2 flex justify-end space-x-2 border-t pt-2">{t21}{t22}</div>;
    $[73] = t21;
    $[74] = t22;
    $[75] = t23;
  } else {
    t23 = $[75];
  }
  let t24;
  if ($[76] !== t10 || $[77] !== t20 || $[78] !== t23 || $[79] !== t8 || $[80] !== t9) {
    t24 = <div className={t8}>{t9}{t10}{t20}{t23}</div>;
    $[76] = t10;
    $[77] = t20;
    $[78] = t23;
    $[79] = t8;
    $[80] = t9;
    $[81] = t24;
  } else {
    t24 = $[81];
  }
  let t25;
  if ($[82] !== T0 || $[83] !== t11 || $[84] !== t12 || $[85] !== t24) {
    t25 = <T0 className={t11} align={t12}>{t24}</T0>;
    $[82] = T0;
    $[83] = t11;
    $[84] = t12;
    $[85] = t24;
    $[86] = t25;
  } else {
    t25 = $[86];
  }
  let t26;
  if ($[87] !== T1 || $[88] !== t13 || $[89] !== t14 || $[90] !== t15 || $[91] !== t16 || $[92] !== t25) {
    t26 = <T1 modal={t13} open={t14} onOpenChange={t15}>{t16}{t25}</T1>;
    $[87] = T1;
    $[88] = t13;
    $[89] = t14;
    $[90] = t15;
    $[91] = t16;
    $[92] = t25;
    $[93] = t26;
  } else {
    t26 = $[93];
  }
  let t27;
  if ($[94] !== t17 || $[95] !== t26) {
    t27 = <div className={t17}>{t26}</div>;
    $[94] = t17;
    $[95] = t26;
    $[96] = t27;
  } else {
    t27 = $[96];
  }
  return t27;
}
function _temp(l) {
  return l.id;
}